import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.5 3.21q0-.908.697-1.554a2.38 2.38 0 0 1 1.678-.646h4.75q0 .908.698 1.554A2.38 2.38 0 0 0 12 3.21q.98 0 1.678-.646.697-.647.697-1.554h4.75q.98 0 1.677.646T21.5 3.21v17.6q0 .908-.698 1.554a2.38 2.38 0 0 1-1.677.646H4.875a2.38 2.38 0 0 1-1.678-.646Q2.5 21.717 2.5 20.81z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M8 12.51v6M12 9.51v9M16 6.51v12"
    }, null, -1)
  ])))
}
export default { render: render }